export default __webpack_public_path__ + "images/bridgeport-apartments-usps-png-logo-2.png";